export const API = "http://api.tele724.online";
// export const API = "http://127.0.0.1:8000";
// export const API = process.env.REACT_APP_API_URL;
export const MAX_ITEM = 48;
